"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionedHashVersionKzg = void 0;
exports.versionedHashVersionKzg = 1;
//# sourceMappingURL=kzg.js.map